<template>
  <div id="app">
    <router-view name="navbar-top">sticky="true"</router-view>
    <app-people-search-modal-wrapper></app-people-search-modal-wrapper>
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import ImageUploader from "vue-image-upload-resize";
Vue.use(ImageUploader);






import PeopleSearchModalWrapper from "./components/personComponents/personSearchComponents/PeopleSearchModalWrapper";

//import PersonDetail from './components/PersonDetail.vue';



export default {
  name: "app",
  components: {
    appPeopleSearchModalWrapper: PeopleSearchModalWrapper

    //appHome:Home,
    //appPersonDetail:PersonDetail
  }
};
</script>

<style></style>
